module.exports = __webpack_public_path__ + "static/desktop-dashboard-full-1861dba5b247b2f817d4e1029f392139.png";